import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin, Facebook, Instagram } from "lucide-react";
import { BUSINESS, CITIES, NAV } from "@/data/site";

export default function Footer() {
  const serviceLinks = NAV.find((n) => n.label === "Services").children.slice(1);
  return (
    <footer className="relative bg-adn-charcoal text-zinc-400 overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 noise-overlay opacity-[0.03]" />
      <div className="relative max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <img src={BUSINESS.logo} alt="A.D.N Stucco Inc" className="h-14 w-auto object-contain bg-white/95 p-1" />
              <div className="font-heading font-extrabold text-lg leading-none">
                <span className="text-adn-red">A.D.N</span> <span className="text-white">STUCCO</span>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed">Central Florida's trusted stucco &amp; plastering contractor. Licensed, insured, and committed to lasting quality craftsmanship.</p>
            <div className="flex gap-3 mt-6">
              <a href={BUSINESS.social.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="p-2 border border-white/20 hover:border-adn-red hover:text-white transition-colors"><Facebook size={18} /></a>
              <a href={BUSINESS.social.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="p-2 border border-white/20 hover:border-adn-red hover:text-white transition-colors"><Instagram size={18} /></a>
            </div>
          </div>

          <div>
            <h4 className="label-accent text-white mb-6">Services</h4>
            <ul className="space-y-3 text-sm">
              {serviceLinks.map((s) => (
                <li key={s.to}><Link to={s.to} className="hover:text-adn-red transition-colors">{s.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-accent text-white mb-6">Service Areas</h4>
            <ul className="space-y-3 text-sm grid grid-cols-2 gap-x-4">
              {CITIES.slice(0, 12).map((c) => (
                <li key={c.slug}><Link to={`/service-areas/${c.slug}`} className="hover:text-adn-red transition-colors">{c.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-accent text-white mb-6">Get In Touch</h4>
            <ul className="space-y-4 text-sm">
              <li><a href={BUSINESS.phoneHref} className="flex items-start gap-3 hover:text-adn-red transition-colors"><Phone size={18} className="text-adn-red mt-0.5" /> {BUSINESS.phone}</a></li>
              <li><a href={`mailto:${BUSINESS.email}`} className="flex items-start gap-3 hover:text-adn-red transition-colors break-all"><Mail size={18} className="text-adn-red mt-0.5" /> {BUSINESS.email}</a></li>
              <li className="flex items-start gap-3"><Clock size={18} className="text-adn-red mt-0.5" /> {BUSINESS.hours}</li>
              <li className="flex items-start gap-3"><MapPin size={18} className="text-adn-red mt-0.5" /> Serving {BUSINESS.region}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs">
          <p>&copy; {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p>Licensed &amp; Insured &middot; Free Estimates &middot; Central Florida</p>
        </div>
      </div>
      <div className="relative font-heading font-extrabold text-white/[0.03] text-[16vw] leading-none text-center select-none pb-4 tracking-tighter">STUCCO</div>
    </footer>
  );
}
